import { put } from "../util";

export interface OverfoertLektionLinjeDTO {
  efteruddannelsestypenr: number;
  indberettedeLektioner: number;
}

export interface UpdateOverfoerteLektionerBody {
  linjer: OverfoertLektionLinjeDTO[];
}

export interface PersonEfteruddannelseIndberetningDTO {
  id: string;
  registreringsDato?: string | null;
  efteruddannelseIndberetningstype: string;
  lektionerGennemfoert?: number | null;
  retteDato?: string | null;
  retteInit?: string | null;
}

/**
 * Rettelsen i AIKA og synkroniseringen til indberetningsportalen kan lykkes uafhængigt.
 * Lykkes AIKA-delen, svarer backenden 200 — også hvis portalen fejlede — så klienten opdaterer sin
 * visning. `portalSynkroniseret: false` betyder, at advokaten endnu ikke kan se lektionerne, og at
 * et nyt (idempotent) gem kan forsøge igen.
 */
export interface OverfoerteLektionerResultatDTO {
  indberetning: PersonEfteruddannelseIndberetningDTO;
  portalSynkroniseret: boolean;
  portalBesked?: string | null;
}

/**
 * Opretter eller retter de lektioner, der er overført IND i `efteruddannelseId`.
 *
 * `efteruddannelseId` er perioden lektionerne overføres TIL — typisk personens aktuelle, åbne
 * periode. Det er modsat indberetningsportalens model, hvor overførslen hører til perioden
 * lektionerne kommer FRA.
 *
 * Kaldet er fuld erstatning: en efteruddannelsestype, der ikke er med i `linjer`, fjernes. Send
 * derfor altid alle typer, der har en værdi.
 */
export const updateOverfoerteLektioner = (
  personId: string,
  efteruddannelseId: string,
  body: UpdateOverfoerteLektionerBody,
): Promise<OverfoerteLektionerResultatDTO> =>
  put<OverfoerteLektionerResultatDTO>({
    query: `person/${encodeURIComponent(personId)}/efteruddannelser/${encodeURIComponent(efteruddannelseId)}/overfoertelektioner`,
    body,
  });
